import React, { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { ResponsiveLine } from "@nivo/line";
import { groupBy } from "lodash";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import NewWindow from "react-new-window";
import { Link } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import Link2 from "@material-ui/core/Link";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary
  },
  text: {
    textAlign: "center",
    color: "darkgray",
    marginLeft: "10%"
  },
  heading: {
    marginLeft: "10%"
  }
}));

const LinePlotSubPlot = ({ sheetData, category }) => {
  const classes = useStyles();
  let comp_item_resline = [];
  const AreaLayer = (props) => {
    const xScale = props.xScale;
    const yScale = props.yScale;
    const data = props.data;
    const midPoint = props.midPoint;
    const lDates = props.lDates;

    return (
      <>
        <text x={xScale(0)} y={yScale(-0.8)} fill={"gray"} fontSize="12">
          {data[0].data[0].date}
        </text>
        <line
          x1={xScale(0)}
          y1={70}
          x2={xScale(0)}
          y2="100"
          stroke="red"
          stroke-dasharray="4 "
        ></line>

        <text x={xScale(midPoint)} y={yScale(-0.8)} fill={"gray"} fontSize="12">
          {data[0].data[midPoint].date}
        </text>
        <line
          x1={xScale(midPoint)}
          y1={70}
          x2={xScale(midPoint)}
          y2="110"
          stroke="black"
          stroke-dasharray="4 "
        ></line>

        <text x={xScale(lDates) - 25} y="90" fill={"gray"} fontSize="12">
          {data[0].data[lDates].date}
        </text>
        <line
          x1={xScale(lDates)}
          y1={70}
          x2={xScale(lDates)}
          y2="90"
          stroke="black"
          stroke-dasharray="4 "
        ></line>

        {/* <text x={xScale(26)} y={yScale(-0.8)} fill={"gray"} fontSize="12">
          {data[0].data[28].date}
        </text> */}
      </>
    );
  };

  const themess = {
    // "background": "#ffffff",
    textColor: "gray",
    fontSize: 8,
    axis: {
      domain: {
        line: {
          stroke: "#777777",
          strokeWidth: 1
        }
      },
      ticks: {
        line: {
          stroke: "#777777",
          strokeWidth: 1
        }
      }
    },
    grid: {
      line: {
        stroke: "#dddddd",
        strokeWidth: 1
      }
    }
  };

  function methodName(myTicker) {
    // https://marketchameleon.com/Overview/MATX/Fair-Value-Price/
    const url =
      "https://marketchameleon.com/Overview/" +
      myTicker +
      "/Fair-Value-Price/?pap_aid=sairam";
    window.open(
      url,
      "mywindow",
      "menubar=1,resizable=1,width=550,height=750,top=-250, left=200"
    );
  }

  comp_item_resline = sheetData.map(function (d, i) {
    const symbol = d[0].symbol;
    const name = d[0].name;
    const sector = d[0].sector;
    const industry = d[0].industry;
    const skew = d[0].skew;
    const ivPercent = d[0].ivPercent;
    const eDate = d[0].eDate;
    //
    const expMove =
      d[0].expMove === " " ? "-" : (+d[0].expMove * 100).toFixed(1) + "%";
    const prevMove =
      d[0].prevMove === "" ? "-" : (+d[0].prevMove * 100).toFixed(1) + "%";

    const startDate = d[0].data[0].date;
    const lDates = d[0].data.length - 1;
    const midPoint = Math.floor(lDates / 2);
    const endDsheetate = d[0].data[lDates].date;
    const linkTo =
      "https://marketchameleon.com/Overview/" +
      name +
      "/Fair-Value-Price/?pap_aid=sairam";
    return [
      <>
        {/* <span>{d[0].symbol}</span>, */}
        {/* style={{flexGrow: 1 }} */}

        <Grid
          item
          key={d[0].symbol}
          // xs={20} sm ={12}
          // spacing={3}
          style={{
            borderStyle: "dotted",
            borderWidth: "1px",
            borderColor: "#EDEDED"
          }}
        >
          <Link2
            // component="button"
            // variant="body2"
            onClick={() => {
              methodName(symbol);
            }}
          >
            <Typography className={classes.text} variant="subtitle2">
              {symbol}
            </Typography>

            <Typography
              className={classes.heading}
              variant="subtitle2"
              // nowrap="True"
            >
              {name}
            </Typography>

            <Typography
              className={classes.heading}
              variant="subtitle2"
              // nowrap="True"
            >
              {sector}
            </Typography>

            <div
              draggable="true"
              style={{
                maxWidth: "320px",
                margin: "0 auto",
                alignContent: "center",
                height: "200px"
              }}
            >
              <ResponsiveLine
                data={d}
                lDates={lDates}
                midPoint={midPoint}
                theme={themess}
                margin={{ top: 10, right: 10, bottom: 50, left: 50 }}
                enableGridX={false}
                useMesh={false}
                enableGridY={false}
                enablePoints={false}
                enableArea={true}
                areaOpacity={0.6}
                colors={["rgb(97, 205, 187)", "rgb(244, 117, 96)"]}
                xScale={{
                  type: "linear",
                  min: 0,
                  max: "auto"
                }}
                yScale={{
                  type: "linear",
                  min: -0.5,
                  max: 1.2
                }}
                // axisLeft={{
                //   legend: "cumu return",
                //   legendOffset: 12
                // }}
                axisLeft={{
                  format: (value) => `${Number(value) * 100} %`
                }}
                axisBottom={null}
                // markers={[
                //   {
                //     axis: "y",
                //     value: 0,
                //     lineStyle: { stroke: "white", strokeWidth: 2 },
                //     legend: "y marker",
                //     legendColor: "white",
                //     legendOrientation: "vertical"
                //   }
                // ]}
                layers={[
                  "grid",
                  "markers",
                  "areas",
                  AreaLayer,
                  "lines",
                  "axes",
                  "points",
                  "legends"
                ]}
              />
            </div>
          </Link2>
          <div className={classes.root}>
            <Grid container spacing={0.1}>
              <Grid item xs={6}>
                <Typography className={classes.text} variant="subtitle2">
                  Expected Move
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography className={classes.text} variant="subtitle2">
                 +/- {expMove}
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography className={classes.text} variant="subtitle2">
                  Previous Move
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography className={classes.text} variant="subtitle2">
                  {prevMove}
                </Typography>
              </Grid>
            </Grid>
          </div>
        </Grid>
      </>
    ];
  });

  return (
    <>
      <Grid item xs={12}>
        <Typography
          display="block"
          variant="h1"
          component="h2"
          style={{
            textAlign: "center",
            color: "white"
          }}
        >
          {category}
        </Typography>
      </Grid>
      <Divider />
      <br></br>

      {comp_item_resline}
    </>
  );
};

export default LinePlotSubPlot;
